import React, { FC } from 'react';
import { Icon, IconProps } from '../Icon';

export const CalendarAlt: FC<IconProps> = (props) => (
  <Icon {...props}>
    <path
      fill="currentColor"
      d="M27 15a2 2 0 0 0-2-2H7a2 2 0 0 0-2 2v10c0 1.1.9 2 2 2h18a2 2 0 0 0 2-2V15Zm0-5a2 2 0 0 0-2-2H7a2 2 0 0 0-2 2v1.5a4 4 0 0 1 2-.5h18a4 4 0 0 1 2 .5V10Zm2 15a4 4 0 0 1-4 4H7a4 4 0 0 1-4-4V10a4 4 0 0 1 4-4h1V4a1 1 0 0 1 2 0v2h12V4a1 1 0 0 1 2 0v2h1a4 4 0 0 1 4 4v15Z"
    />
  </Icon>
);
